/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserDefinition } from './UserDefinition';
import {
    UserDefinitionFromJSON,
    UserDefinitionFromJSONTyped,
    UserDefinitionToJSON,
} from './UserDefinition';

/**
 * 
 * @export
 * @interface GetUsers200Response
 */
export interface GetUsers200Response {
    /**
     * 
     * @type {Array<UserDefinition>}
     * @memberof GetUsers200Response
     */
    records?: Array<UserDefinition>;
}

/**
 * Check if a given object implements the GetUsers200Response interface.
 */
export function instanceOfGetUsers200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetUsers200ResponseFromJSON(json: any): GetUsers200Response {
    return GetUsers200ResponseFromJSONTyped(json, false);
}

export function GetUsers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUsers200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(UserDefinitionFromJSON)),
    };
}

export function GetUsers200ResponseToJSON(value?: GetUsers200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(UserDefinitionToJSON)),
    };
}

